// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../state/criteria';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../shared/components/formatted-number-input';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import PartsCoverageSearchButtonFooter from './parts-coverage-search-criteria-footer';

const PartsCoverageSearchCriteria = props =>
    <div className='part-coverage-search-criteria'>
        <div className='part-coverage-criteria-fields'>
            <LabeledCriteria
                className='part-number-criteria'
                isRequired={true}
                label='PART_NUMBER'
                maxLength={18}
                onInputChange={props.handlePartNumberChange}
                onKeyPress={props.handleSubmitOnEnterKeyPress}
                placeholder='PART_NUMBER'
                type='text'
                value={props.criteria.partNumber}
            />
            <LabeledCriteria
                className='pin-criteria'
                isRequired={false}
                label='PIN'
                maxLength={18}
                onInputChange={props.handlePinChange}
                onKeyPress={props.handleSubmitOnEnterKeyPress}
                placeholder='PIN'
                type='text'
                value={props.criteria.pin}
            />
            <div className='labeled-criteria form-group'>
                <h3 className='form-group-title optional-criteria'>
                    <FormattedMessage id='HOURS'/>
                </h3>
                <FormattedNumberInput
                    allowNegative={false}
                    isValidInput={value => value < 1000000}
                    onKeyPress={props.handleSubmitOnEnterKeyPress}
                    onValueChange={props.handleCurrentMachineHoursChange}
                    value={props.criteria.currentMachineHours}
                />
            </div>
        </div>
        <PartsCoverageSearchButtonFooter
            canRunReport={props.criteria.partNumber !== ''}
            onCriteriaReset={props.onCriteriaReset}
            onPartSearchExecute={props.onCreatePartCoverageSearchReport}
        />
    </div>;

PartsCoverageSearchCriteria.displayName = 'PartsCoverageSearchCriteria';
PartsCoverageSearchCriteria.propTypes = {
    criteria: PropTypes.instanceOf(Criteria),
    handleCurrentMachineHoursChange: PropTypes.func.isRequired,
    handlePartNumberChange: PropTypes.func.isRequired,
    handlePinChange: PropTypes.func.isRequired,
    handleSubmitOnEnterKeyPress: PropTypes.func.isRequired,
    onCreatePartCoverageSearchReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired
};

export default PartsCoverageSearchCriteria;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/components/parts-coverage-search-criteria.js